export default __webpack_public_path__ + "static/media/location.df8e33a9.svg";